import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../lib/api';

type Doc = {
  id: number;
  title: string;
  versions_count: number;
  updated_at: string;
};

export default function ProjectIfc() {
  const { id: projectId } = useParams<{ id: string }>();
  const [docs, setDocs] = useState<Doc[]>([]);

  useEffect(() => {
    if (!projectId) return;
    api
      .get<{ documents: Doc[] }>(`/projects/${projectId}/documents`)
      .then((r) => setDocs(r.documents));
  }, [projectId]);

  // heuristique simple : docs dont le titre contient "ifc" ou catégorie IFC
  const candidates = docs.filter((d) => /\bifc\b/i.test(d.title));

  return (
    <>
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="card-title">Viewer IFC</div>
        <div className="card-meta">
          Les maquettes IFC s'ouvrent directement dans le viewer 3D depuis n'importe quel document du
          projet dont la dernière version est un fichier <code>.ifc</code>. Crée un document, dépose
          la maquette, et ouvre-le.
        </div>
      </div>

      {candidates.length === 0 && (
        <div className="card card-meta">
          Aucun document IFC détecté dans ce projet. Crée un document "Archi IFC" (ou équivalent)
          depuis l'onglet Documents, puis déposes-y la maquette <code>.ifc</code>.
        </div>
      )}

      <div className="grid-2">
        {candidates.map((d) => (
          <Link
            key={d.id}
            to={`/projets/${projectId}/documents/${d.id}`}
            className="card"
            style={{ display: 'block' }}
          >
            <div className="card-title">{d.title}</div>
            <div className="card-meta">
              {d.versions_count} version{d.versions_count > 1 ? 's' : ''}
            </div>
          </Link>
        ))}
      </div>
    </>
  );
}
